import { render, staticRenderFns } from "./DoubleBarCharts.vue?vue&type=template&id=0e66fd7d&scoped=true"
import script from "./DoubleBarCharts.vue?vue&type=script&lang=js"
export * from "./DoubleBarCharts.vue?vue&type=script&lang=js"
import style0 from "./DoubleBarCharts.vue?vue&type=style&index=0&id=0e66fd7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-lo_875f195a559ab6cb5ed9ea4190ad0331/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e66fd7d",
  null
  
)

export default component.exports